<template>
  <swiper
    :modules="modules"
    :slides-per-view="'1'"
    :looped-slides="list.length"
    :space-between="28"
    :speed="600"
    :loop="true"
    :navigation="{
      nextEl: '.arrowNext',
      prevEl: '.arrowPrev',
    }"
    :breakpoints = breakpoints
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <figure :class="{'active': reverse}"><img :src="item.pic" alt="photo"></figure>
      <dl>
        <dt v-html="item.dt"></dt>
        <dd v-html="item.dd"></dd>
      </dl>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  width: auto;
  border-radius: .48rem;
  height: auto;
  overflow: hidden;
  background: module.$white;
  transform: scale(.8);
  opacity: 0;
  transition: all 600ms module.$ease;
  transition-property: opacity, transform;
  dl{
    padding: 1.6rem;
    dt{
      font-size: 1.24rem;
      font-weight: 700;
      color: module.$sub;
    }
    dd{
      line-height: 1.6;
      margin: .8rem 0 0;
    }
  }
}
.swiper-slide-active,
.swiper-slide-next,
.swiper-slide-next + .swiper-slide{
  opacity: 1;
  transform: scale(1);
}
img{
  width: 100%;
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const { reverse } = toRefs(props);
    const breakpoints = {
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    };

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      reverse,
      breakpoints,
    }
  },
}
</script>
